export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('StatesMap', () => ({
        selectedState: '',
        mouseOnState(event, state) {
          this.selectedState = state;
          const tooltip = document.getElementById('tooltip_state');
          tooltip.style.top = `${event.pageY - 60}px`;
          tooltip.style.left =
            event.pageX - tooltip.clientWidth / 2 < 16
              ? `16px`
              : event.pageX + tooltip.clientWidth / 2 > window.innerWidth
                ? 'auto'
                : `${event.pageX - tooltip.clientWidth / 2}px`;
          tooltip.style.right =
            event.pageX + tooltip.clientWidth / 2 > window.innerWidth
              ? `16px`
              : 'auto';
        },
        mouseOutState() {
          this.selectedState = '';
        },
      }));
    });
  },
};
